import { configureStore } from '@reduxjs/toolkit'
import surveys from '../slices/surveys-reducer'
import analyze from '../slices/analyze-reducer'
import account from '../slices/account-reducer'

export const store = configureStore({
  reducer: {
    surveys: surveys,
    analyze: analyze,
    account: account
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch